module.exports = __webpack_public_path__ + "static/img/shushiIcon.ebfea6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/shushiIcon.png
// module id = 5zX4
// module chunks = 0